<template>
  <div class="modal fade" id="add-channel" tabindex="-1" aria-hidden="true">
    <div
      class="modal-dialog modal-lg modal-dialog-centered modal-simple modal-upgrade-plan"
    >
      <div class="modal-content">
        <div class="modal-body">
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
            id="channel-add-close"
          ></button>
          <div class="text-center">
            <h4 class="mb-8">{{ $t("iptv.add") }}</h4>
          </div>
          <div class="row g-6">
            <div class="col-12">
              <label class="form-label" for="">{{ $t("iptv.name") }}</label>
              <input
                type="text"
                class="form-control"
                id="basic-url3"
                aria-describedby="basic-addon34"
                :placeholder="$t('iptv.name')"
                v-model="channel.name"
                @input="validate"
                :class="{ 'is-invalid': errors.name }"
              />
              <div v-if="errors.name" class="invalid-feedback">
                {{ errors.name }}
              </div>
            </div>
            <div class="col-12">
              <label class="form-label" for="">{{ $t("iptv.logo") }}</label>
              <input
                class="form-control"
                type="file"
                accept="image/*"
                @change="selectImage"
                ref="imageFile"
                id="formFile"
              />
              <img
                v-if="currentImageUrl"
                class="h-16"
                :src="currentImageUrl"
                alt="Logo Image"
              />
            </div>
            <div class="col-12">
              <label class="form-label" for="">{{ $t("iptv.url") }}</label>
              <input
                type="text"
                v-model="channel.url"
                @input="validate"
                class="form-control"
                id="basic-url3"
                aria-describedby="basic-addon34"
                :placeholder="$t('iptv.url')"
                :class="{ 'is-invalid': errors.url }"
              />
              <div v-if="errors.url" class="invalid-feedback">
                {{ errors.url }}
              </div>
            </div>
            <div class="col-12 d-flex justify-content-end">
              <button
                class="btn btn-success"
                :disabled="!validated"
                @click.prevent="store"
              >
                {{ $t("accounts.add") }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment, { months } from "moment";
import { hasPrivilege } from "../../global_constants.js";
import { mapGetters } from "vuex";
import axios from "axios";
export default {
  name: "channelAdd",
  props: ["visible"],
  computed: {
    ...mapGetters(["user", "settings"]),
  },
  data() {
    return {
      loading: true,
      validated: true,
      paid: "0",
      notes: "",
      channel: {
        name: "",
        logo: null,
        url: "",
      },
      currentImageUrl: null,
      errors: {
        name: null,
        url: null,
      },
    };
  },
  async created() {
    this.validate();
    this.loading = false;
  },
  methods: {
    hide() {
      this.$emit("hide-details");
    },
    formatDate(date) {
      return moment(date).format("MMMM Do YYYY, h:mm a");
    },
    hasPrivilege(privilege) {
      return hasPrivilege(this.user, privilege);
    },
    async store() {
      this.loading = true;
      var data = new FormData();
      data.append("logo", this.channel.logo);
      data.append("name", this.channel.name);
      data.append("url", this.channel.url);
      const response = await axios.post("iptv", data, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      if (response.status == 200) {
        document.getElementById("channel-add-close").click();
        this.$notify({
          text: this.$t("messages.channel_added_successfully"),
          type: "success",
        });
        this.$emit("updated");
      }
      this.loading = false;
    },
    selectImage() {
      this.channel.logo = this.$refs.imageFile.files.item(0);
      this.currentImageUrl = URL.createObjectURL(this.channel.logo);
    },
    validate() {
      this.validated = true;
      this.errors.name = null;
      this.errors.url = null;
      if (this.channel.name == "") {
        this.validated = false;
        this.errors.name = this.$t("errors.iptv.name_empty");
      }
      if (this.channel.url == "") {
        this.validated = false;
        this.errors.url = this.$t("errors.iptv.url_empty");
      }
    },
  },
};
</script>
